import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ProcedureRecordService {
  constructor(private http: HttpClient) {}

  createProcedure(payload: any) {
    return this.http.post(`${environment.apiUrl}/procedure`, payload);
  }

  getProcedureById(id: string) {
    return this.http.get(`${environment.apiUrl}/procedure/${id}`);
  }

  updateProcedure(id: string, payload: any) {
    return this.http.put(`${environment.apiUrl}/procedure/${id}`, payload);
  }

  archiveProcedure(id: string) {
    return this.http.delete(`${environment.apiUrl}/procedure/${id}`);
  }

  unarchiveProcedure(id: string) {
    return this.http.patch(`${environment.apiUrl}/procedure/${id}/unarchive`, {});
  }

  getPagedProcedures(payload: any) {
    return this.http.post(`${environment.apiUrl}/procedure/paged`, payload);
  }

  getProceduresByDateRange(payload: { startDate: string; endDate: string }) {
    return this.http.post(`${environment.apiUrl}/procedure/get-by-date-range`, payload);
  }
  
  getNurseMonthlyProcedures(nurseId: string, year: number, month: number) {
    return this.http.get(`${environment.apiUrl}/procedure/nurse/${nurseId}/month/${year}/${month}`);
  }

  getPagedNurseProcedures(nurseId: string, payload: any) {
    return this.http.post(`${environment.apiUrl}/procedure/nurse/${nurseId}/monthly/paged`, payload);
  }

  getClientMonthlyProcedures(clientId: string, year: number, month: number) {
    return this.http.get(`${environment.apiUrl}/procedure/client/${clientId}/month/${year}/${month}`);
  }

  getPagedClientProcedures(clientId: string, payload: any) {
    return this.http.post(`${environment.apiUrl}/procedure/client/${clientId}/monthly/paged`, payload);
  }
}

